import { createContext, PropsWithChildren, useContext, useReducer } from 'react';
import { WsMessage } from '../../clients/chat/types';

// TODO: chat-module, add type
const CurrentChatSessionContext = createContext<{
    messages: WsMessage[];
    subscribedToChatSession: boolean;
    chatSessionId: string;
}>({
    messages: [],
    subscribedToChatSession: false,
    chatSessionId: null
});
// TODO: chat-module, add type
const CurrentChatDispatchContext = createContext(null);

const useCurrentChatDispatch = () => useContext(CurrentChatDispatchContext);
const useCurrentChatSessionContext = () => useContext(CurrentChatSessionContext);

export default function CurrentChatContextProvider({ children }: PropsWithChildren) {
    // TODO: chat-module, add type
    const [currentChatSession, dispatch] = useReducer(
        (state, action) => {
            switch (action.type) {
                case 'SET_MESSAGES':
                    return { ...state, messages: action.payload };
                case 'SET_CHAT_SESSION_STATE':
                    return { ...state, subscribedToChatSession: action.payload };
                case 'SET_CHAT_SESSION_ID':
                    return {
                        ...state,
                        chatSessionId: action.payload
                    };
                default:
                    return state;
            }
        },
        {
            messages: [],
            subscribedToChatSession: false,
            chatSessionId: null
        }
    );

    return (
        <CurrentChatDispatchContext.Provider value={dispatch}>
            <CurrentChatSessionContext.Provider value={currentChatSession}>
                {children}
            </CurrentChatSessionContext.Provider>
        </CurrentChatDispatchContext.Provider>
    );
}

export { useCurrentChatDispatch, useCurrentChatSessionContext };
